import { HeroHowItWorks } from '@/components/home/HowItWorksVideo.tsx';
import RoleActionButton from './RoleActionButton';

type HeroSectionProps = {
  onBorrowerClick: () => void;
  onInvestorClick: () => void;
};

export default function HeroSection({ onBorrowerClick, onInvestorClick }: HeroSectionProps) {
  return (
    <div className="w-full px-4 sm:px-6 py-8 sm:py-12">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 items-center">
          {/* Left Side - Content */}
          <section className="order-1 lg:order-1">
            <div className="w-full h-full flex flex-col justify-center items-center lg:items-start gap-8">
              <div className="w-full flex flex-col justify-start items-center lg:items-start gap-6">
                <div className="w-full flex justify-center lg:justify-start items-center">
                  <div className="text-center lg:text-left text-[#113D7B] text-[clamp(16px,4vw,20px)] font-avenir font-[650] break-words">
                    Welcome to EquiPool
                  </div>
                </div>
                <div className="w-full text-center lg:text-left">
                  <span className="text-black text-[clamp(28px,8vw,48px)] font-normal break-words">
                    Your Capital, Your Terms,{' '}
                  </span>
                  <span className="text-black text-[clamp(28px,8vw,48px)] font-extrabold italic break-words">
                    Your Move.
                  </span>
                </div>
                <div className="w-full text-center lg:text-left text-black text-[clamp(16px,4vw,20px)] font-avenir font-medium break-words">
                  Fair, fast, and transparent financing backed by real assets. Whether you’re investing or borrowing,
                  our seamless platform puts you in control — with clarity, confidence, and no hidden costs.
                </div>
                <div className="w-full flex flex-col sm:flex-row justify-center lg:justify-start items-center gap-4 sm:gap-2">
                  <RoleActionButton
                    label="Borrow"
                    icon="/icons.svg"
                    iconAlt="Handshake icon"
                    variant="primary"
                    onClick={onBorrowerClick}
                  />
                  <RoleActionButton
                    label="Invest"
                    icon="/invest.svg"
                    iconAlt="Investment icon"
                    variant="secondary"
                    onClick={onInvestorClick}
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="order-2 lg:order-2">
            <div className="w-full aspect-video lg:min-h-[400px] relative bg-gray-200 overflow-hidden rounded-lg flex items-center justify-center">
              <HeroHowItWorks />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
